var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose-plane",class:{active:_vm.activeStepId===4}},[_c('div',{staticClass:"plane-inner"},[_c('div',{staticClass:"header-title",domProps:{"innerHTML":_vm._s(_vm.content.title)}}),_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.content.teaser)}}),_c('plane-item-component',{on:{"toggle":_vm.toggle}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }